import { render } from "./Configuraciones.vue?vue&type=template&id=e4f82f74&scoped=true"
import script from "./Configuraciones.vue?vue&type=script&lang=js"
export * from "./Configuraciones.vue?vue&type=script&lang=js"

import "./Configuraciones.vue?vue&type=style&index=0&id=e4f82f74&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e4f82f74"

export default script